// Pied de page : un seul bloc « Transparence IA » en fin de page, factuel, d'après la configuration réelle.
import { Link } from 'react-router';
import { useSession } from '../lib/session.tsx';

const NOMS: Record<string, string> = { anthropic: 'Anthropic (Claude)', gemini: 'Google (Gemini)', openai_compatible: 'modèle compatible OpenAI' };

export function PiedDePage() {
  const { etat } = useSession();
  const ia = etat?.ia;
  return (
    <footer className="pied">
      {ia && (
        <p data-aiact="art50">
          <strong>Transparence IA. </strong>
          {ia.disponible
            ? <>Certaines fonctions (propositions de contrôles, aide à l’analyse de dossier, lecture des photos et des documents scannés, reformulation à la demande d’une section de mémoire technique) s’appuient sur un système d’intelligence artificielle
              ({NOMS[ia.fournisseur] ?? ia.fournisseur}{ia.local ? ', hébergé en interne' : ''}). Ses propositions sont marquées comme telles et
              doivent être validées par une personne habilitée ; aucune décision n’est prise automatiquement. </>
            : <>Aucun service d’intelligence artificielle n’est activé : les détections reposent sur des règles métier explicites et sur vos saisies. </>}
          <Link to="/transparence">En savoir plus</Link>
        </p>
      )}
      <div className="pied-liens">
        <Link to="/mentions-legales">Mentions légales</Link>
        <Link to="/confidentialite">Confidentialité</Link>
        <Link to="/transparence">Transparence IA</Link>
        <span>TRAME — nom de travail</span>
        <span>Création VLT GRAPHIQUE</span>
      </div>
    </footer>
  );
}
